module.exports = __webpack_public_path__ + "img/icon1.ecaebbb6.png";